import React from 'react';

interface StrategyFreshFacesBadgeProps {
  className?: string;
}

const StrategyFreshFacesBadge: React.FC<StrategyFreshFacesBadgeProps> = ({
  className = '',
}): React.ReactElement => {
  return (
    <div
      className={`px-1.5 py-1 rounded-md border border-green-600 inline-flex 
                                  justify-center items-center gap-0.5 overflow-hidden ${className}`}
    >
      <div className="text-center justify-start text-green-600 text-xs font-normal font-['Inter'] leading-4">
        Fresh Faces
      </div>
    </div>
  );
};

export default StrategyFreshFacesBadge;
